import { MAIN_NAV_MENU_LOCALSTORAGE_KEY, ONBOARDING_FORM_LOCALSTORAGE_KEY, ONBOARDING_STEPPER_LOCALSTORAGE_KEY } from './constants'

export const clearLocalStorageOnLogout = () => {
  localStorage.removeItem(ONBOARDING_FORM_LOCALSTORAGE_KEY)
  localStorage.removeItem(ONBOARDING_STEPPER_LOCALSTORAGE_KEY)
  localStorage.setItem(MAIN_NAV_MENU_LOCALSTORAGE_KEY, 'false')
}
